module.exports = __webpack_public_path__ + "img/10_newYouth_ljj.f9ebd7a6.png";